import CargoCompanyAddRequest, {
  CargoCompanyAddRequestContractMaintenancePolicy,
} from "../../../../api/raily/cargo-company/cargo-company/add/cargo-company-add-request";
import ContractMaintenancePolicy from "../../../../types/contract-maintenance-policy";
import CargoCompanyAddParams from "./cargo-company-add-params";

const createContractMaintenancePolicy = (
  contractMaintenancePolicy: ContractMaintenancePolicy,
): CargoCompanyAddRequestContractMaintenancePolicy => {
  switch (contractMaintenancePolicy) {
    case ContractMaintenancePolicy.BASIC:
      return CargoCompanyAddRequestContractMaintenancePolicy.BASIC;
    case ContractMaintenancePolicy.AUCTION:
      return CargoCompanyAddRequestContractMaintenancePolicy.AUCTION;
  }
};

const create = (params: CargoCompanyAddParams): CargoCompanyAddRequest => {
  return {
    taxId: params.taxNumber,
    regon: params.companyId || null,
    krsNo: params.nationalCourtRegister,
    companyName: params.name,
    displayName: params.displayName,
    headquartersAddressString: params.address,
    contractMaintenancePolicy: createContractMaintenancePolicy(
      params.contractMaintenancePolicy,
    ),
    notes: params.notes,
  };
};

const cargoCompanyAddParamsFactory = {
  create,
};

export default cargoCompanyAddParamsFactory;
